var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4Allowance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 226.402,
    height: 270.092,
    viewBox: "0 0 226.402 270.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25462",
    "data-name": "Rectangle 25462",
    width: 207.006,
    height: 200.049,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25427",
    "data-name": "Rectangle 25427",
    width: 167.791,
    height: 167.715,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25429",
    "data-name": "Rectangle 25429",
    width: 25.698,
    height: 32.493,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25431",
    "data-name": "Rectangle 25431",
    width: 29.484,
    height: 17.052,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25433",
    "data-name": "Rectangle 25433",
    width: 29.484,
    height: 17.051,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25435",
    "data-name": "Rectangle 25435",
    width: 17.683,
    height: 29.795,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25437",
    "data-name": "Rectangle 25437",
    width: 32.125,
    height: 29.94,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25439",
    "data-name": "Rectangle 25439",
    width: 32.125,
    height: 29.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25445",
    "data-name": "Rectangle 25445",
    width: 29.132,
    height: 32.397,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25454",
    "data-name": "Rectangle 25454",
    width: 25.225,
    height: 33.668,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25455",
    "data-name": "Rectangle 25455",
    width: 35.507,
    height: 35.601,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25456",
    "data-name": "Rectangle 25456",
    width: 41.994,
    height: 36.552,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25457",
    "data-name": "Rectangle 25457",
    width: 51.011,
    height: 32.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25458",
    "data-name": "Rectangle 25458",
    width: 49.277,
    height: 30.8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25459",
    "data-name": "Rectangle 25459",
    width: 62.91,
    height: 30.336,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25460",
    "data-name": "Rectangle 25460",
    width: 53.792,
    height: 27.71,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87918",
    "data-name": "Group 87918",
    transform: "translate(-14524 -19759.957)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4987",
    "data-name": "Ellipse 4987",
    cx: 113.201,
    cy: 113.201,
    r: 113.201,
    transform: "translate(14524 19759.957)",
    fill: "#ffded7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87818",
    "data-name": "Group 87818",
    transform: "translate(14621 19782.361)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_24009",
    "data-name": "Rectangle 24009",
    width: 32.882,
    height: 42.174,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203106",
    "data-name": "Path 203106",
    d: "M14.7,2.96l.159.1c.268.774.606,2.005.953,3.306v.208l-.884.069Z",
    transform: "translate(-0.106 -0.021)",
    fill: "#ffa900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87849",
    "data-name": "Group 87849",
    transform: "translate(14534 19830)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87725",
    "data-name": "Group 87725",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87724",
    "data-name": "Group 87724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87723",
    "data-name": "Group 87723",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87674",
    "data-name": "Group 87674",
    transform: "translate(23.506 89.633)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87673",
    "data-name": "Group 87673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87672",
    "data-name": "Group 87672",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25428",
    "data-name": "Rectangle 25428",
    width: 28.268,
    height: 15.098,
    transform: "translate(0.272 26.175) rotate(-66.396)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276110",
    "data-name": "Path 276110",
    d: "M28.97,70.3c-.036-.016-.069-.033-.1-.052L20.025,90.485a.864.864,0,0,1,.106.04,1.108,1.108,0,0,1,.571,1.458,1.092,1.092,0,0,1-.158.257l8.65,3.781a1.094,1.094,0,0,1,.081-.291,1.108,1.108,0,0,1,1.458-.572l8.838-20.224A1.106,1.106,0,0,1,39,73.476L30.427,69.73A1.106,1.106,0,0,1,28.97,70.3Zm2.4,8.807A4.077,4.077,0,1,1,26,81.211,4.078,4.078,0,0,1,31.372,79.108Z",
    transform: "translate(-16.89 -66.597)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87677",
    "data-name": "Group 87677",
    transform: "translate(54.699 145.928)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87676",
    "data-name": "Group 87676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87675",
    "data-name": "Group 87675",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25430",
    "data-name": "Rectangle 25430",
    width: 28.268,
    height: 15.097,
    transform: "matrix(0.999, -0.055, 0.055, 0.999, 0.217, 1.76)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276111",
    "data-name": "Path 276111",
    d: "M44.452,124.024a1.1,1.1,0,0,1,0,.114l22.049-1.2c-.005-.037-.009-.074-.012-.113a1.107,1.107,0,0,1,1.046-1.165,1.083,1.083,0,0,1,.3.025l-.515-9.426a1.161,1.161,0,0,1-.3.059,1.107,1.107,0,0,1-1.165-1.046l-22.039,1.2a1.106,1.106,0,0,1-1.044,1.165l.51,9.342A1.106,1.106,0,0,1,44.452,124.024Zm6.786-6.106a4.077,4.077,0,1,1,4.293,3.849A4.077,4.077,0,0,1,51.238,117.918Z",
    transform: "translate(-40.567 -109.169)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87680",
    "data-name": "Group 87680",
    transform: "translate(86.503 41.913)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87679",
    "data-name": "Group 87679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87678",
    "data-name": "Group 87678",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25432",
    "data-name": "Rectangle 25432",
    width: 28.268,
    height: 15.097,
    transform: "translate(0.217 1.759) rotate(-3.127)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276112",
    "data-name": "Path 276112",
    d: "M68.359,45.837a1.1,1.1,0,0,1,0,.114l22.049-1.2c-.005-.037-.009-.075-.012-.113a1.107,1.107,0,0,1,1.046-1.165,1.084,1.084,0,0,1,.3.025l-.515-9.426a1.161,1.161,0,0,1-.3.059,1.107,1.107,0,0,1-1.165-1.046l-22.039,1.2a1.106,1.106,0,0,1-1.044,1.165l.51,9.342A1.106,1.106,0,0,1,68.359,45.837Zm6.786-6.106a4.077,4.077,0,1,1,4.293,3.849A4.077,4.077,0,0,1,75.145,39.731Z",
    transform: "translate(-64.473 -30.984)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87683",
    "data-name": "Group 87683",
    transform: "translate(166.192 119.152)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87682",
    "data-name": "Group 87682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87681",
    "data-name": "Group 87681",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25434",
    "data-name": "Rectangle 25434",
    width: 28.268,
    height: 15.097,
    transform: "translate(0.222 28.405) rotate(-85.563)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276113",
    "data-name": "Path 276113",
    d: "M128.379,92.3c-.039,0-.076-.008-.113-.015L126.558,114.3a1.116,1.116,0,0,1,1.132,1.192,1.145,1.145,0,0,1-.065.3l9.411.73a1.15,1.15,0,0,1-.019-.3,1.108,1.108,0,0,1,1.189-1.018l1.707-22.005A1.105,1.105,0,0,1,138.9,92l-9.327-.724A1.108,1.108,0,0,1,128.379,92.3Zm5.16,7.53a4.077,4.077,0,1,1-4.381,3.749A4.076,4.076,0,0,1,133.54,99.829Z",
    transform: "translate(-124.383 -88.997)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87686",
    "data-name": "Group 87686",
    transform: "translate(133.604 49.626)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87685",
    "data-name": "Group 87685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87684",
    "data-name": "Group 87684",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25436",
    "data-name": "Rectangle 25436",
    width: 28.268,
    height: 15.097,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.291, 17.797)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276114",
    "data-name": "Path 276114",
    d: "M120.85,39.991c-.024-.029-.045-.061-.067-.092L103.445,53.575a.933.933,0,0,1,.076.085,1.1,1.1,0,0,1-.446,1.707l5.847,7.413a1.122,1.122,0,0,1,.209-.22,1.108,1.108,0,0,1,1.555.184l17.329-13.668a1.107,1.107,0,0,1,.184-1.555l-5.794-7.346A1.107,1.107,0,0,1,120.85,39.991Zm-2.034,8.9a4.077,4.077,0,1,1-5.726-.676A4.077,4.077,0,0,1,118.816,48.891Z",
    transform: "translate(-99.552 -36.445)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87689",
    "data-name": "Group 87689",
    transform: "translate(58.751 4.901)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87688",
    "data-name": "Group 87688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87687",
    "data-name": "Group 87687",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25438",
    "data-name": "Rectangle 25438",
    width: 28.268,
    height: 15.097,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.291, 17.797)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276115",
    "data-name": "Path 276115",
    d: "M64.585,6.372c-.024-.029-.045-.061-.067-.092L47.18,19.956a.935.935,0,0,1,.076.085,1.1,1.1,0,0,1-.446,1.707l5.847,7.413a1.122,1.122,0,0,1,.209-.22,1.108,1.108,0,0,1,1.555.184L71.75,15.457a1.107,1.107,0,0,1,.184-1.555L66.14,6.555A1.107,1.107,0,0,1,64.585,6.372Zm-2.034,8.9a4.077,4.077,0,1,1-5.726-.676A4.077,4.077,0,0,1,62.551,15.272Z",
    transform: "translate(-43.287 -2.826)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87692",
    "data-name": "Group 87692",
    transform: "translate(109.353 107.114)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87691",
    "data-name": "Group 87691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87690",
    "data-name": "Group 87690",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25440",
    "data-name": "Rectangle 25440",
    width: 28.268,
    height: 15.097,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.291, 17.797)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276116",
    "data-name": "Path 276116",
    d: "M102.621,83.2c-.024-.029-.045-.061-.067-.092L85.216,96.787a.935.935,0,0,1,.076.085,1.1,1.1,0,0,1-.446,1.707l5.847,7.413a1.122,1.122,0,0,1,.209-.22,1.108,1.108,0,0,1,1.555.184l17.329-13.669a1.105,1.105,0,0,1,.184-1.554l-5.794-7.346A1.107,1.107,0,0,1,102.621,83.2Zm-2.034,8.9a4.077,4.077,0,1,1-5.726-.676A4.077,4.077,0,0,1,100.587,92.1Z",
    transform: "translate(-81.323 -79.658)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87695",
    "data-name": "Group 87695",
    transform: "translate(79.763 167.835)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87694",
    "data-name": "Group 87694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87693",
    "data-name": "Group 87693",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25442",
    "data-name": "Rectangle 25442",
    width: 28.268,
    height: 15.097,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.291, 17.797)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276117",
    "data-name": "Path 276117",
    d: "M80.379,128.846c-.024-.029-.045-.061-.067-.092L62.974,142.43a.932.932,0,0,1,.076.085,1.1,1.1,0,0,1-.446,1.707l5.847,7.413a1.122,1.122,0,0,1,.209-.219,1.108,1.108,0,0,1,1.555.184l17.329-13.669a1.105,1.105,0,0,1,.184-1.554l-5.794-7.346A1.107,1.107,0,0,1,80.379,128.846Zm-2.034,8.9a4.077,4.077,0,1,1-5.726-.676A4.077,4.077,0,0,1,78.345,137.746Z",
    transform: "translate(-59.081 -125.3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87698",
    "data-name": "Group 87698",
    transform: "translate(148.203 167.651)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87697",
    "data-name": "Group 87697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87696",
    "data-name": "Group 87696",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25444",
    "data-name": "Rectangle 25444",
    width: 15.097,
    height: 28.268,
    transform: "matrix(0.82, -0.572, 0.572, 0.82, 0.288, 8.926)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276118",
    "data-name": "Path 276118",
    d: "M114.032,135.475a1.075,1.075,0,0,1-.1.061l12.636,18.11a.954.954,0,0,1,.09-.069,1.106,1.106,0,0,1,1.541.274,1.123,1.123,0,0,1,.137.27l7.741-5.4a1.137,1.137,0,0,1-.206-.222,1.106,1.106,0,0,1,.275-1.541l-12.629-18.1a1.107,1.107,0,0,1-1.542-.274l-7.672,5.353A1.106,1.106,0,0,1,114.032,135.475Zm8.764,2.553a4.077,4.077,0,1,1-1.011,5.677A4.078,4.078,0,0,1,122.8,138.028Z",
    transform: "translate(-110.564 -125.174)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87701",
    "data-name": "Group 87701",
    transform: "translate(13.432 161.495)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87700",
    "data-name": "Group 87700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87699",
    "data-name": "Group 87699",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25446",
    "data-name": "Rectangle 25446",
    width: 15.097,
    height: 28.268,
    transform: "matrix(0.82, -0.572, 0.572, 0.82, 0.288, 8.926)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276119",
    "data-name": "Path 276119",
    d: "M12.728,130.848a1.074,1.074,0,0,1-.1.061l12.636,18.11a.955.955,0,0,1,.09-.069,1.106,1.106,0,0,1,1.541.274,1.124,1.124,0,0,1,.137.27l7.741-5.4a1.135,1.135,0,0,1-.206-.222,1.106,1.106,0,0,1,.275-1.541l-12.629-18.1a1.107,1.107,0,0,1-1.542-.274L13,129.307A1.106,1.106,0,0,1,12.728,130.848Zm8.764,2.553a4.077,4.077,0,1,1-1.011,5.677A4.078,4.078,0,0,1,21.493,133.4Z",
    transform: "translate(-9.259 -120.546)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25448",
    "data-name": "Rectangle 25448",
    width: 6.624,
    height: 6.624,
    transform: "translate(25.426 39.442)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10944",
    "data-name": "Line 10944",
    x2: 16.19,
    transform: "translate(34.258 42.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10945",
    "data-name": "Line 10945",
    x2: 16.19,
    transform: "translate(34.258 42.386)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25449",
    "data-name": "Rectangle 25449",
    width: 6.624,
    height: 6.624,
    transform: "translate(25.426 27.667)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10946",
    "data-name": "Line 10946",
    x2: 16.19,
    transform: "translate(34.258 30.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10947",
    "data-name": "Line 10947",
    x2: 16.19,
    transform: "translate(34.258 30.611)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25450",
    "data-name": "Rectangle 25450",
    width: 6.624,
    height: 6.624,
    transform: "translate(25.426 15.892)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10948",
    "data-name": "Line 10948",
    x2: 16.19,
    transform: "translate(34.258 18.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10949",
    "data-name": "Line 10949",
    x2: 16.19,
    transform: "translate(34.258 18.836)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276120",
    "data-name": "Path 276120",
    d: "M20.355,14.47,22,17.008l6.718-5.823",
    transform: "translate(6.725 3.695)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276121",
    "data-name": "Path 276121",
    d: "M20.131,22.925l1.792,2.389,5.822-4.928",
    transform: "translate(6.65 6.735)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276122",
    "data-name": "Path 276122",
    d: "M20.131,31.758l1.792,2.389,5.822-4.928",
    transform: "translate(6.65 9.653)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25451",
    "data-name": "Rectangle 25451",
    width: 6.624,
    height: 6.624,
    transform: "translate(25.426 75.636)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10950",
    "data-name": "Line 10950",
    x2: 16.19,
    transform: "translate(34.258 78.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10951",
    "data-name": "Line 10951",
    x2: 16.19,
    transform: "translate(34.258 78.58)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25452",
    "data-name": "Rectangle 25452",
    width: 6.624,
    height: 6.624,
    transform: "translate(25.426 63.861)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10952",
    "data-name": "Line 10952",
    x2: 16.19,
    transform: "translate(34.258 66.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10953",
    "data-name": "Line 10953",
    x2: 16.19,
    transform: "translate(34.258 66.805)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25453",
    "data-name": "Rectangle 25453",
    width: 6.624,
    height: 6.624,
    transform: "translate(25.426 52.086)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10954",
    "data-name": "Line 10954",
    x2: 16.19,
    transform: "translate(34.258 55.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10955",
    "data-name": "Line 10955",
    x2: 16.19,
    transform: "translate(34.258 55.03)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276123",
    "data-name": "Path 276123",
    d: "M20.355,41.676,22,44.214l6.718-5.823",
    transform: "translate(6.725 12.683)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276124",
    "data-name": "Path 276124",
    d: "M20.131,50.131l1.792,2.389,5.822-4.928",
    transform: "translate(6.65 15.723)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276125",
    "data-name": "Path 276125",
    d: "M20.131,58.964l1.792,2.389,5.822-4.928",
    transform: "translate(6.65 18.641)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276126",
    "data-name": "Path 276126",
    d: "M112.741,26.667s6.09,1.064,8.85-.077a23.382,23.382,0,0,0,4.933-2.851l-6.186-3.494-6.08,3.448Z",
    transform: "translate(37.245 6.688)",
    fill: "#fec47a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276127",
    "data-name": "Path 276127",
    d: "M112.741,26.667s6.09,1.064,8.85-.077a23.382,23.382,0,0,0,4.933-2.851l-6.186-3.494-6.08,3.448Z",
    transform: "translate(37.245 6.688)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276128",
    "data-name": "Path 276128",
    d: "M94,75.163l.452.968,1.7-.772,1.286,2.751,1.7-.773,1.286,2.751,1.7-.772,1.286,2.751,1.7-.773,1.285,2.751,1.7-.773,1.286,2.753,1.7-.773,1.193,2.553a28.987,28.987,0,0,0,3.605-11.863c.367-7.587-1.491-9.6-2.884-16.151s-.861-27.028-.861-27.028L92.281,16.355s.439,19.093.584,26.833S92.6,58.28,95.337,65.565c1.866,4.972.021,8.107-1.34,9.6",
    transform: "translate(30.486 5.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276129",
    "data-name": "Path 276129",
    d: "M94,75.163l.452.968,1.7-.772,1.286,2.751,1.7-.773,1.286,2.751,1.7-.772,1.286,2.751,1.7-.773,1.285,2.751,1.7-.773,1.286,2.753,1.7-.773,1.193,2.553a28.987,28.987,0,0,0,3.605-11.863c.367-7.587-1.491-9.6-2.884-16.151s-.861-27.028-.861-27.028L92.281,16.355s.439,19.093.584,26.833S92.6,58.28,95.337,65.565C97.2,70.536,95.358,73.672,94,75.163Z",
    transform: "translate(30.486 5.403)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10956",
    "data-name": "Line 10956",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(124.447 44.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10957",
    "data-name": "Line 10957",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(124.447 44.169)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10958",
    "data-name": "Line 10958",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(133.681 48.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10959",
    "data-name": "Line 10959",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(133.681 48.209)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10960",
    "data-name": "Line 10960",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(134.055 52.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10961",
    "data-name": "Line 10961",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(134.055 52.74)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10962",
    "data-name": "Line 10962",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(134.362 56.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10963",
    "data-name": "Line 10963",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(134.362 56.26)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10964",
    "data-name": "Line 10964",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(134.819 59.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10965",
    "data-name": "Line 10965",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(134.819 59.754)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10966",
    "data-name": "Line 10966",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(135.029 63.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10967",
    "data-name": "Line 10967",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(135.029 63.603)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10968",
    "data-name": "Line 10968",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(135.637 67.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10969",
    "data-name": "Line 10969",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(135.637 67.071)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10970",
    "data-name": "Line 10970",
    x2: 6.779,
    y2: 3.406,
    transform: "translate(137.132 71.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10971",
    "data-name": "Line 10971",
    x2: 6.779,
    y2: 3.406,
    transform: "translate(137.132 71.848)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10972",
    "data-name": "Line 10972",
    x2: 5.699,
    y2: 3.263,
    transform: "translate(138.307 76.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10973",
    "data-name": "Line 10973",
    x2: 5.699,
    y2: 3.263,
    transform: "translate(138.307 76.545)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10974",
    "data-name": "Line 10974",
    x2: 5.594,
    y2: 3.725,
    transform: "translate(138.174 80.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10975",
    "data-name": "Line 10975",
    x2: 5.594,
    y2: 3.725,
    transform: "translate(138.174 80.944)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10976",
    "data-name": "Line 10976",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(124.402 48.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10977",
    "data-name": "Line 10977",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(124.402 48.217)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10978",
    "data-name": "Line 10978",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(124.736 51.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10979",
    "data-name": "Line 10979",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(124.736 51.889)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10980",
    "data-name": "Line 10980",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(125.096 55.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10981",
    "data-name": "Line 10981",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(125.096 55.711)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10982",
    "data-name": "Line 10982",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(125.252 59.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10983",
    "data-name": "Line 10983",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(125.252 59.258)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10984",
    "data-name": "Line 10984",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(125.408 62.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10985",
    "data-name": "Line 10985",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(125.408 62.805)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10986",
    "data-name": "Line 10986",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(126.044 66.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10987",
    "data-name": "Line 10987",
    x2: 6.851,
    y2: 3.616,
    transform: "translate(126.044 66.423)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10988",
    "data-name": "Line 10988",
    x2: 6.109,
    y2: 3.266,
    transform: "translate(127.29 70.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10989",
    "data-name": "Line 10989",
    x2: 6.109,
    y2: 3.266,
    transform: "translate(127.29 70.867)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10990",
    "data-name": "Line 10990",
    x2: 4.686,
    y2: 2.919,
    transform: "translate(128.703 75.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10991",
    "data-name": "Line 10991",
    x2: 4.686,
    y2: 2.919,
    transform: "translate(128.703 75.081)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276130",
    "data-name": "Path 276130",
    d: "M175.3.156H159.57c-7.558,4.466-14.311,8.242-14.864,8.529-2.087,1.084-12.915,2.22-15.746,2.263s-16.119-3.559-18.01-2.883-2.18.317-3.211,1.668S98.146,22.868,97.763,24.29s-2.449,11.975-2.412,14.4.273,4.65,1.252,5.16a2.427,2.427,0,0,0,2.871-.165c.838-.741,1.1-2.2,1.482-3.624a5.584,5.584,0,0,0,.082-2.592s5.828,2.784,6.8,2.689a5.974,5.974,0,0,0,2.367-1.33,12.742,12.742,0,0,0,2.469.044c.847-.134,6.012-1.184,7.373-2.1s2.308-2.625,2.174-3.472a15.8,15.8,0,0,0-.682-2.3l4.095-2.126s7.387,4.217,12.06,2.811a26.482,26.482,0,0,0,8.875-4.506,12.09,12.09,0,0,1,2.283-1.491L175.3,18.13Z",
    transform: "translate(31.5 0.052)",
    fill: "#fec47a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276131",
    "data-name": "Path 276131",
    d: "M175.3.156H159.57c-7.558,4.466-14.311,8.242-14.864,8.529-2.087,1.084-12.915,2.22-15.746,2.263s-16.119-3.559-18.01-2.883-2.18.317-3.211,1.668S98.146,22.868,97.763,24.29s-2.449,11.975-2.412,14.4.273,4.65,1.252,5.16a2.427,2.427,0,0,0,2.871-.165c.838-.741,1.1-2.2,1.482-3.624a5.584,5.584,0,0,0,.082-2.592s5.828,2.784,6.8,2.689a5.974,5.974,0,0,0,2.367-1.33,12.742,12.742,0,0,0,2.469.044c.847-.134,6.012-1.184,7.373-2.1s2.308-2.625,2.174-3.472a15.8,15.8,0,0,0-.682-2.3l4.095-2.126s7.387,4.217,12.06,2.811a26.482,26.482,0,0,0,8.875-4.506,12.09,12.09,0,0,1,2.283-1.491L175.3,18.13Z",
    transform: "translate(31.5 0.052)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276132",
    "data-name": "Path 276132",
    d: "M112.12,18.7s-5.482,6.72-5.062,7.724a11.122,11.122,0,0,0,2.566,3.765,6.736,6.736,0,0,0,3.544,1.525,3.244,3.244,0,0,0,2.714-2.429,2.181,2.181,0,0,0-.349-1.654",
    transform: "translate(35.36 6.176)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276133",
    "data-name": "Path 276133",
    d: "M112.527,27.526s3.231-3,3.335-4.179",
    transform: "translate(37.174 7.713)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276134",
    "data-name": "Path 276134",
    d: "M108.5,15.474s-7.35,6.262-7.123,7.877,1.812,7.418,2.553,8.256c0,0,1.976,2.236,4.281,2.16",
    transform: "translate(33.49 5.112)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276135",
    "data-name": "Path 276135",
    d: "M107.17,11.643s-8.709,7.376-9.387,8.033-.926,2.928-.452,4.823,1.553,6.33,1.893,7.377a2.683,2.683,0,0,0,1.241,1.8",
    transform: "translate(32.073 3.846)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276136",
    "data-name": "Path 276136",
    d: "M111.983,7.506a3.509,3.509,0,0,0-3.066.572,14.161,14.161,0,0,0-1.789,2.051",
    transform: "translate(35.39 2.437)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276137",
    "data-name": "Path 276137",
    d: "M115.052,10.8c-.454-.653-2.864.043-3.3,1.507",
    transform: "translate(36.92 3.486)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276138",
    "data-name": "Path 276138",
    d: "M117.178,14.5a2.958,2.958,0,0,0-1.847.959l-.595.818",
    transform: "translate(37.904 4.791)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276139",
    "data-name": "Path 276139",
    d: "M171.985,51.174c-13.546-.967-22.539-2.691-22.711-2.685a35.283,35.283,0,0,0-12.169.749c-6.573,1.614-21.863,2.961-21.863,2.961s-2.363.765-2.6,1.189-5.933,14.433-6.721,16.35a5.613,5.613,0,0,0,.109,5.046c.8,1.551,4.905,4.385,7.248,6.653s3.871,4.5,4.941,3.573.774-2.894.774-2.894,10.3-1.345,12.372-1.58,2.858.339,3.081-1.06-1.177-2.87-1.177-2.87,1.257-1.518.858-2.294-2.023-.846-3.058-.728-4.493,1.107-4.493,1.107-1.635-1.046-1.447-1.634,2.3-4.4,2.3-4.4a25.048,25.048,0,0,0,2.835-.366c1.694-.307,3.011-.684,4.293-.249a25.5,25.5,0,0,0,7.622.491c1.694-.307,6.1-3.261,6.1-3.261l23.7,5.159Z",
    transform: "translate(34.813 15.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276140",
    "data-name": "Path 276140",
    d: "M171.985,51.174c-13.546-.967-22.539-2.691-22.711-2.685a35.283,35.283,0,0,0-12.169.749c-6.573,1.614-21.863,2.961-21.863,2.961s-2.363.765-2.6,1.189-5.933,14.433-6.721,16.35a5.613,5.613,0,0,0,.109,5.046c.8,1.551,4.905,4.385,7.248,6.653s3.871,4.5,4.941,3.573.774-2.894.774-2.894,10.3-1.345,12.372-1.58,2.858.339,3.081-1.06-1.177-2.87-1.177-2.87,1.257-1.518.858-2.294-2.023-.846-3.058-.728-4.493,1.107-4.493,1.107-1.635-1.046-1.447-1.634,2.3-4.4,2.3-4.4a25.048,25.048,0,0,0,2.835-.366c1.694-.307,3.011-.684,4.293-.249a25.5,25.5,0,0,0,7.622.491c1.694-.307,6.1-3.261,6.1-3.261l23.7,5.159Z",
    transform: "translate(34.813 15.945)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276141",
    "data-name": "Path 276141",
    d: "M143.429,48.879,142.307,77.64l10.653,2.8.56-31Z",
    transform: "translate(47.012 16.148)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276142",
    "data-name": "Path 276142",
    d: "M143.429,48.879,142.307,77.64l10.653,2.8.56-31Z",
    transform: "translate(47.012 16.148)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276143",
    "data-name": "Path 276143",
    d: "M157.141,49.716l-6.265-.415-.561,31,6.826,1.64Z",
    transform: "translate(49.658 16.287)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276144",
    "data-name": "Path 276144",
    d: "M157.141,49.716l-6.265-.415-.561,31,6.826,1.64Z",
    transform: "translate(49.658 16.287)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276145",
    "data-name": "Path 276145",
    d: "M113.937,55.917a8.57,8.57,0,0,0,3.072,4.2",
    transform: "translate(37.64 18.473)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276146",
    "data-name": "Path 276146",
    d: "M111.056,58.482s.436,2.458,2.142,3.128",
    transform: "translate(36.688 19.32)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276147",
    "data-name": "Path 276147",
    d: "M112.3,68.842l-.093.918s3.6,2,4.53,5.561",
    transform: "translate(37.069 22.743)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276148",
    "data-name": "Path 276148",
    d: "M114.4,67.834l2.023,2.093s4.353.891,5.175.656,6.386-2.272,8.691-.438",
    transform: "translate(37.794 22.41)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276149",
    "data-name": "Path 276149",
    d: "M122.486,69.185l-2.164-.093-2.553-1.14s1.376-1.729.564-3.011",
    transform: "translate(38.906 21.454)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276150",
    "data-name": "Path 276150",
    d: "M119.813,69.9s2.611-.213,3.129,1.6a2.836,2.836,0,0,1-.611,2.847",
    transform: "translate(39.581 23.09)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276151",
    "data-name": "Path 276151",
    d: "M99.313,56.889s17.762,10.28,21.229,12.636,10.8,4.507,10.8,4.507-.009,25.213.14,31.575,1.111,24.284,1.111,24.284-10.6-5.484-15.637-8.606c-3.99-2.474-18.376-12.419-18.376-12.419s-.275-18.206.088-28.4c.335-9.368.644-23.582.644-23.582",
    transform: "translate(32.534 18.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276152",
    "data-name": "Path 276152",
    d: "M99.313,56.889s17.762,10.28,21.229,12.636,10.8,4.507,10.8,4.507-.009,25.213.14,31.575,1.111,24.284,1.111,24.284-10.6-5.484-15.637-8.606c-3.99-2.474-18.376-12.419-18.376-12.419s-.275-18.206.088-28.4C99,71.1,99.313,56.889,99.313,56.889Z",
    transform: "translate(32.534 18.794)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276153",
    "data-name": "Path 276153",
    d: "M100.212,73.611l26.654,15.134.335,30.163-10.547-6.117-.185-6.427a111.677,111.677,0,0,1-16.258-9.822Z",
    transform: "translate(33.106 24.318)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10992",
    "data-name": "Line 10992",
    x2: 4.839,
    y2: 2.412,
    transform: "translate(154.267 99.559)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10993",
    "data-name": "Line 10993",
    x2: 4.839,
    y2: 2.412,
    transform: "translate(154.124 102.088)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10994",
    "data-name": "Line 10994",
    x2: 4.839,
    y2: 2.412,
    transform: "translate(153.981 104.617)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276154",
    "data-name": "Path 276154",
    d: "M100.245,77.6,126.89,93.367l-.025-4.622L100.211,73.611Z",
    transform: "translate(33.106 24.318)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276155",
    "data-name": "Path 276155",
    d: "M100.245,77.6,126.89,93.367l-.025-4.622L100.211,73.611Z",
    transform: "translate(33.106 24.318)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10995",
    "data-name": "Line 10995",
    x1: 0.112,
    y1: 19.157,
    transform: "translate(149.463 111.525)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10996",
    "data-name": "Line 10996",
    x2: 26.175,
    y2: 14.81,
    transform: "translate(133.637 107.249)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10997",
    "data-name": "Line 10997",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(134.064 111.878)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10998",
    "data-name": "Line 10998",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(134.064 111.878)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10999",
    "data-name": "Line 10999",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(134.208 114.451)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11000",
    "data-name": "Line 11000",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(134.208 114.451)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11001",
    "data-name": "Line 11001",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(151.389 120.883)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11002",
    "data-name": "Line 11002",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(151.389 120.883)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11003",
    "data-name": "Line 11003",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(151.486 125.026)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11004",
    "data-name": "Line 11004",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(151.486 125.026)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11005",
    "data-name": "Line 11005",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(151.583 129.169)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11006",
    "data-name": "Line 11006",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(151.583 129.169)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11007",
    "data-name": "Line 11007",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(151.68 133.312)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11008",
    "data-name": "Line 11008",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(151.68 133.312)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11009",
    "data-name": "Line 11009",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(134.249 117.391)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11010",
    "data-name": "Line 11010",
    x2: 5.818,
    y2: 3.225,
    transform: "translate(134.249 117.391)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276156",
    "data-name": "Path 276156",
    d: "M124.033,56.277A6.781,6.781,0,0,1,119.753,60c-3.468,1.26-6.114,3.531-9.007,5.25s-6.173,4.884-4.8,6.894,4.365,1.868,7.4.644,9.994-6.78,12.323-6.733a64.109,64.109,0,0,0,8.808-.651c2.564-.378,5.069-1.9,8.3-3.979",
    transform: "translate(34.895 18.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276157",
    "data-name": "Path 276157",
    d: "M124.033,56.277A6.781,6.781,0,0,1,119.753,60c-3.468,1.26-6.114,3.531-9.007,5.25s-6.173,4.884-4.8,6.894,4.365,1.868,7.4.644,9.994-6.78,12.323-6.733a64.109,64.109,0,0,0,8.808-.651c2.564-.378,5.069-1.9,8.3-3.979",
    transform: "translate(34.895 18.592)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276158",
    "data-name": "Path 276158",
    d: "M69.334,58.44l-3.8-.023s-5.887,17.848-8.124,24.145-3.388,15.709-3.388,15.709L76.658,69.564Z",
    transform: "translate(17.848 19.299)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276159",
    "data-name": "Path 276159",
    d: "M69.334,58.44l-3.8-.023s-5.887,17.848-8.124,24.145-3.388,15.709-3.388,15.709L76.658,69.564Z",
    transform: "translate(17.848 19.299)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276160",
    "data-name": "Path 276160",
    d: "M82.247,59.464,67.9,57.961S60.03,76.416,58.178,84.589A84.2,84.2,0,0,1,54.5,97.143,170.2,170.2,0,0,0,71.8,77.982C79.479,67.794,84.738,60.62,84.738,60.62Z",
    transform: "translate(18.005 19.148)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276161",
    "data-name": "Path 276161",
    d: "M82.247,59.464,67.9,57.961S60.03,76.416,58.178,84.589A84.2,84.2,0,0,1,54.5,97.143,170.2,170.2,0,0,0,71.8,77.982C79.479,67.794,84.738,60.62,84.738,60.62Z",
    transform: "translate(18.005 19.148)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87704",
    "data-name": "Group 87704",
    transform: "translate(75.7 78.805)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87703",
    "data-name": "Group 87703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87702",
    "data-name": "Group 87702",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276162",
    "data-name": "Path 276162",
    d: "M82.127,60.077l-1-.059-13.264-.782s-6.7,15.924-8.343,21.935S56.9,92.9,56.9,92.9Z",
    transform: "translate(-56.902 -59.236)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276163",
    "data-name": "Path 276163",
    d: "M69.069,70.545c1.6,1,1.519,3.994-.169,6.678s-4.352,4.047-5.947,3.044-1.519-3.994.169-6.678,4.352-4.047,5.947-3.044",
    transform: "translate(20.418 23.196)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276164",
    "data-name": "Path 276164",
    d: "M69.069,70.545c1.6,1,1.519,3.994-.169,6.678s-4.352,4.047-5.947,3.044-1.519-3.994.169-6.678S67.474,69.542,69.069,70.545Z",
    transform: "translate(20.418 23.196)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276165",
    "data-name": "Path 276165",
    d: "M91.024,60.154,82.85,58.3S71.7,76.4,65.286,83.593,52.829,98.319,52.829,98.319s8.254-3.435,22.185-14.75S93.759,63.042,93.759,63.042Z",
    transform: "translate(17.452 19.261)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276166",
    "data-name": "Path 276166",
    d: "M91.024,60.154,82.85,58.3S71.7,76.4,65.286,83.593,52.829,98.319,52.829,98.319s8.254-3.435,22.185-14.75S93.759,63.042,93.759,63.042Z",
    transform: "translate(17.452 19.261)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87707",
    "data-name": "Group 87707",
    transform: "translate(73.812 79.646)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87706",
    "data-name": "Group 87706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87705",
    "data-name": "Group 87705",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276167",
    "data-name": "Path 276167",
    d: "M89.018,60.393,82.6,59.868S73.154,73.741,67.979,80.192s-12.5,15.278-12.5,15.278S66.519,87.359,73.5,79.319s17.49-18.5,17.49-18.5Z",
    transform: "translate(-55.483 -59.868)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276168",
    "data-name": "Path 276168",
    d: "M98.389,62.5l-7.846-3.371S76.085,76.161,66.513,86.116,52.981,98.047,52.981,98.047l-.612,2.431s13.288-4.647,25.953-17.47S98.707,63.892,98.707,63.892Z",
    transform: "translate(17.301 19.533)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276169",
    "data-name": "Path 276169",
    d: "M98.389,62.5l-7.846-3.371S76.085,76.161,66.513,86.116,52.981,98.047,52.981,98.047l-.612,2.431s13.288-4.647,25.953-17.47S98.707,63.892,98.707,63.892Z",
    transform: "translate(17.301 19.533)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87710",
    "data-name": "Group 87710",
    transform: "translate(73.058 80.597)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87709",
    "data-name": "Group 87709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87708",
    "data-name": "Group 87708",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276170",
    "data-name": "Path 276170",
    d: "M96.91,63.109l-5.733-2.526S76.867,75.9,70.335,82.66,54.916,97.135,54.916,97.135A31.88,31.88,0,0,0,69.075,89.7C75.43,83.759,96.91,63.109,96.91,63.109",
    transform: "translate(-54.916 -60.582)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276171",
    "data-name": "Path 276171",
    d: "M105.407,66.168,99.178,61.24S70.933,84.878,64.487,88.874a141.84,141.84,0,0,1-12.881,7.007L49.453,99.4s7.575.463,24.741-8.643,32.161-22.877,32.161-22.877Z",
    transform: "translate(16.337 20.231)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276172",
    "data-name": "Path 276172",
    d: "M105.407,66.168,99.178,61.24S70.933,84.878,64.487,88.874a141.84,141.84,0,0,1-12.881,7.007L49.453,99.4s7.575.463,24.741-8.643,32.161-22.877,32.161-22.877Z",
    transform: "translate(16.337 20.231)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87713",
    "data-name": "Group 87713",
    transform: "translate(71.682 83.749)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87712",
    "data-name": "Group 87712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87711",
    "data-name": "Group 87711",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276173",
    "data-name": "Path 276173",
    d: "M103.546,66.412l-5.4-3.46s-19.728,15.5-25.919,20.026a147.246,147.246,0,0,1-13.144,8.653l-5.2,2.884,1.7,1.1s6.478-.331,17.08-6.214,32.233-22.087,32.233-22.087Z",
    transform: "translate(-53.882 -62.952)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276174",
    "data-name": "Path 276174",
    d: "M75.8,78.31c.639,1.152-1.092,3.333-3.866,4.87s-5.538,1.853-6.177.7,1.092-3.33,3.865-4.868,5.54-1.856,6.178-.705",
    transform: "translate(21.68 25.641)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276175",
    "data-name": "Path 276175",
    d: "M75.8,78.31c.639,1.152-1.092,3.333-3.866,4.87s-5.538,1.853-6.177.7,1.092-3.33,3.865-4.868S75.163,77.159,75.8,78.31Z",
    transform: "translate(21.68 25.641)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276176",
    "data-name": "Path 276176",
    d: "M108.372,68.922l-2.228-4.772S88.31,79.356,75.81,86.292A143.4,143.4,0,0,1,50.349,97.067l-1.936,3.31s10.5.041,29.116-9.729,30.864-17.406,30.864-17.406Z",
    transform: "translate(15.994 21.192)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276177",
    "data-name": "Path 276177",
    d: "M108.372,68.922l-2.228-4.772S88.31,79.356,75.81,86.292A143.4,143.4,0,0,1,50.349,97.067l-1.936,3.31s10.5.041,29.116-9.729,30.864-17.406,30.864-17.406Z",
    transform: "translate(15.994 21.192)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87716",
    "data-name": "Group 87716",
    transform: "translate(74.921 87.209)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87715",
    "data-name": "Group 87715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87714",
    "data-name": "Group 87714",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276178",
    "data-name": "Path 276178",
    d: "M105.594,69.669l-2.852-4.116S87.983,78.041,81.788,82.212,61.709,93.234,59.432,93.737a12.013,12.013,0,0,0-3.116,1l2.367,1.622a82.073,82.073,0,0,0,19.838-8.662c10.692-6.374,26.695-16.133,26.695-16.133Z",
    transform: "translate(-56.317 -65.553)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276179",
    "data-name": "Path 276179",
    d: "M108.027,78.855s1.769-1.115,2.16-4.551.6-5.838.6-5.838-23.2,13.512-31.858,17.782A88.713,88.713,0,0,1,59.07,93.153c-2.247.4-9.548,1.662-9.548,1.662l-4.461,5.3a32.809,32.809,0,0,0,18.1-.38c9.785-3.045,33.211-10.979,35.527-12.085s9.342-8.792,9.342-8.792",
    transform: "translate(14.886 22.618)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276180",
    "data-name": "Path 276180",
    d: "M108.027,78.855s1.769-1.115,2.16-4.551.6-5.838.6-5.838-23.2,13.512-31.858,17.782A88.713,88.713,0,0,1,59.07,93.153c-2.247.4-9.548,1.662-9.548,1.662l-4.461,5.3a32.809,32.809,0,0,0,18.1-.38c9.785-3.045,33.211-10.979,35.527-12.085S108.027,78.855,108.027,78.855Z",
    transform: "translate(14.886 22.618)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87719",
    "data-name": "Group 87719",
    transform: "translate(61.53 92.757)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87718",
    "data-name": "Group 87718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87717",
    "data-name": "Group 87717",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276181",
    "data-name": "Path 276181",
    d: "M107.634,78.439s1.557-4.4,1.523-5.6,0-3.116,0-3.116S92.374,79.09,86.4,83.025s-18.8,8.838-21.54,9.334-15.242,2.674-15.242,2.674L46.25,99.89a49.638,49.638,0,0,0,18.783-2.062c9.348-3.109,26.275-8.21,26.715-8.42s6.544-2.176,6.544-2.176Z",
    transform: "translate(-46.251 -69.723)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276182",
    "data-name": "Path 276182",
    d: "M76.457,83.907c.567,1.188-1.294,3.258-4.156,4.624s-5.642,1.511-6.209.323,1.293-3.258,4.156-4.624,5.642-1.511,6.209-.323",
    transform: "translate(21.801 27.454)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276183",
    "data-name": "Path 276183",
    d: "M76.457,83.907c.567,1.188-1.294,3.258-4.156,4.624s-5.642,1.511-6.209.323,1.293-3.258,4.156-4.624S75.89,82.719,76.457,83.907Z",
    transform: "translate(21.801 27.454)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276184",
    "data-name": "Path 276184",
    d: "M68.755,99.738s17.327-6.14,21.387-7a39.383,39.383,0,0,1,8.484-.665l10.23-18.558s-13.087,4.352-19.87,7.725-17.159,8.868-19.407,9.265-13.242.906-13.242.906L50.715,102.9l3.338,1.712,2.675,1.24Z",
    transform: "translate(16.754 24.288)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276185",
    "data-name": "Path 276185",
    d: "M68.755,99.738s17.327-6.14,21.387-7a39.383,39.383,0,0,1,8.484-.665l10.23-18.558s-13.087,4.352-19.87,7.725-17.159,8.868-19.407,9.265-13.242.906-13.242.906L50.715,102.9l3.338,1.712,2.675,1.24Z",
    transform: "translate(16.754 24.288)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87722",
    "data-name": "Group 87722",
    transform: "translate(69.052 99.669)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87721",
    "data-name": "Group 87721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87720",
    "data-name": "Group 87720",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276186",
    "data-name": "Path 276186",
    d: "M105.7,74.919l-8.344,14s-9.439,2.069-15.814,4.03S65.25,99.1,63.706,99.838s-2.158,1.437-3.2,1.527-8.6,1.264-8.6,1.264l4.623-10.737s12.533-.972,13.137-1.125S88.8,81.224,92.27,79.974,105.7,74.919,105.7,74.919",
    transform: "translate(-51.905 -74.919)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276187",
    "data-name": "Path 276187",
    d: "M75.785,85.738c.567,1.188-1.294,3.258-4.156,4.624s-5.642,1.511-6.209.323,1.293-3.258,4.156-4.624,5.642-1.511,6.209-.323",
    transform: "translate(21.579 28.058)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276188",
    "data-name": "Path 276188",
    d: "M75.785,85.738c.567,1.188-1.294,3.258-4.156,4.624s-5.642,1.511-6.209.323,1.293-3.258,4.156-4.624S75.218,84.55,75.785,85.738Z",
    transform: "translate(21.579 28.058)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276189",
    "data-name": "Path 276189",
    d: "M26.677,101.155s13.427-9.226,14.41-9.694S50.1,89.839,51.3,89.536a5.546,5.546,0,0,1,3.83.72c.963.613,8.9,1.515,9.994,1s5.678-2.711,6.7-2.53,2.31.909,1.517,2.9-4.926,5.972-6.46,6.972l-1.534,1,3.38-1.345,8.508-3.524s-.663,3.668-.786,4.531,1.1,2.022-1.209,3.929-4.558,3.652-4.558,3.652a17.972,17.972,0,0,1-1.469,3.382c-.894,1.5-1.008,1.823-1.023,2.634s-1.128,5.5-2.657,6.229a10.878,10.878,0,0,1-6.394.37c-1.342-.565-5.733-.213-5.733-.213s-15.533.041-17.535.059a16.2,16.2,0,0,0-4.51.946l-1.529.73L25.049,101.4Z",
    transform: "translate(8.275 29.306)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276190",
    "data-name": "Path 276190",
    d: "M26.677,101.155s13.427-9.226,14.41-9.694S50.1,89.839,51.3,89.536a5.546,5.546,0,0,1,3.83.72c.963.613,8.9,1.515,9.994,1s5.678-2.711,6.7-2.53,2.31.909,1.517,2.9-4.926,5.972-6.46,6.972l-1.534,1,3.38-1.345,8.508-3.524s-.663,3.668-.786,4.531,1.1,2.022-1.209,3.929-4.558,3.652-4.558,3.652a17.972,17.972,0,0,1-1.469,3.382c-.894,1.5-1.008,1.823-1.023,2.634s-1.128,5.5-2.657,6.229a10.878,10.878,0,0,1-6.394.37c-1.342-.565-5.733-.213-5.733-.213s-15.533.041-17.535.059a16.2,16.2,0,0,0-4.51.946l-1.529.73L25.049,101.4Z",
    transform: "translate(8.275 29.306)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276191",
    "data-name": "Path 276191",
    d: "M26.492,104.27,30.885,115.1l-2.534,1.225Z",
    transform: "translate(8.752 34.446)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276192",
    "data-name": "Path 276192",
    d: "M26.492,104.27,30.885,115.1l-2.534,1.225Z",
    transform: "translate(8.752 34.446)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276193",
    "data-name": "Path 276193",
    d: "M55.624,98.007s4.075-1.034,6.183.309A6.962,6.962,0,0,1,64.548,102s2.008-.9,1.905-2.573l-.106-1.671.786-4.531Z",
    transform: "translate(18.376 30.798)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276194",
    "data-name": "Path 276194",
    d: "M55.624,98.007s4.075-1.034,6.183.309A6.962,6.962,0,0,1,64.548,102s2.008-.9,1.905-2.573l-.106-1.671.786-4.531Z",
    transform: "translate(18.376 30.798)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276195",
    "data-name": "Path 276195",
    d: "M47.835,95.734a6.678,6.678,0,0,1,2.908.757,15.41,15.41,0,0,0,2.25,1.34L55,97.272l2.815,0",
    transform: "translate(15.803 31.626)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276196",
    "data-name": "Path 276196",
    d: "M60.728,102.926s-1.829,2.348-2.053,2.723-1.942,2.67-3.356,3.077a7.429,7.429,0,0,1-3.46-.226s3.013,2.25,4.34,1.833,4.53-7.407,4.53-7.407",
    transform: "translate(17.132 34.002)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276197",
    "data-name": "Path 276197",
    d: "M60.728,102.926s-1.829,2.348-2.053,2.723-1.942,2.67-3.356,3.077a7.429,7.429,0,0,1-3.46-.226s3.013,2.25,4.34,1.833S60.728,102.926,60.728,102.926Z",
    transform: "translate(17.132 34.002)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276198",
    "data-name": "Path 276198",
    d: "M15.961,101.308S27.5,96.394,27.65,96.993s.4,1.684.4,1.684l4.784,19.571s2.011,8.425,1.631,8.473-10.9,2.868-10.9,2.868Z",
    transform: "translate(5.273 32.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276199",
    "data-name": "Path 276199",
    d: "M15.961,101.308S27.5,96.394,27.65,96.993s.4,1.684.4,1.684l4.784,19.571s2.011,8.425,1.631,8.473-10.9,2.868-10.9,2.868Z",
    transform: "translate(5.273 32.026)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276200",
    "data-name": "Path 276200",
    d: "M.155,148.439l31.09-10.64s-1.175-7.088-2.029-10.147c-1.169-4.183-1.2-9.251-2.932-15.109-1.646-5.569-2.255-15.334-2.255-15.334-.74-.987-5.137.576-5.137.576l-18.738,5.4Z",
    transform: "translate(0.051 32.006)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276201",
    "data-name": "Path 276201",
    d: "M.155,148.439l31.09-10.64s-1.175-7.088-2.029-10.147c-1.169-4.183-1.2-9.251-2.932-15.109-1.646-5.569-2.255-15.334-2.255-15.334-.74-.987-5.137.576-5.137.576l-18.738,5.4Z",
    transform: "translate(0.051 32.006)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Allowance);
export default __webpack_public_path__ + "static/media/4_allowance.10c27e6667d9b839bece2a06585c477f.svg";
export { ForwardRef as ReactComponent };